import { render } from "./CreateZone.vue?vue&type=template&id=66a5f946"
import script from "./CreateZone.vue?vue&type=script&lang=js"
export * from "./CreateZone.vue?vue&type=script&lang=js"

import "./CreateZone.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__